import { z } from 'zod';
/** The home-Mac message relay (HiPages lead plan D8, 11 October 2026). When `enabled` and the named EmmA Home
 *  runtime (`box`) checked in within `fresh_seconds` with its Messages SMS account connected, a customer text
 *  approved for Jacky's own number is queued for that Mac to send. Otherwise it opens on the approver's iPhone
 *  (phone handoff), exactly as before. Off by default: the path appears only once the relay is checking in. */
export const PhoneRelaySchema = z.object({
    enabled: z.boolean(),
    box: z.string().regex(/^[a-z0-9][a-z0-9-]{1,62}$/, 'an EmmA Home runtime name'),
    fresh_seconds: z.number().int().min(30).max(900),
});
export const phoneRelayDefaults = { enabled: false, box: 'jacky-macbook', fresh_seconds: 180 };
//# sourceMappingURL=phone-relay.js.map